import { useRef } from 'react'
import { ElectricBorder } from './ElectricBorder'
import './TelegramGift.css'

export function TelegramGift({ received = false, ready = false, purchaseType = 'game' }) {
  const frame = useRef(null)
  const highlighted = received || ready
  return <aside ref={frame} className={`telegram-gift ${highlighted ? 'telegram-gift--received' : ''}`} aria-label='Подарок подписчикам Telegram'>
    <ElectricBorder hostRef={frame} active={highlighted} color='#ffbd59' radius={20} />
    <div className='telegram-gift__art' aria-hidden='true'><span>✦</span><div>🎁</div><span>✧</span></div>
    <div className='telegram-gift__body'>
      <div className='telegram-gift__eyebrow'>PAY2PLAY <span>×</span> TELEGRAM</div>
      <h2>{highlighted
        ? purchaseType === 'topup' ? 'Игра Steam в подарок к пополнению' : 'Ещё одна игра? В подарок.'
        : 'Бонус к покупке — игра Steam'}</h2>
      <p>Для подписчиков нашего канала — случайная игра Steam в подарок. Как получить — в закреплённом сообщении.</p>
      <a className='telegram-gift__cta' href='https://t.me/pay2play_official' target='_blank' rel='noopener noreferrer'>
        Получить игру <span aria-hidden='true'>→</span>
      </a>
      <div className='telegram-gift__note'>Условия получения — в закрепе Telegram-канала.{!received && <> Подписка необязательна и не влияет на получение покупки.</>}</div>
    </div>
  </aside>
}
